import axios from 'axios';
import apiUrl from '../constants';
import jwt from 'jsonwebtoken';
import CryptoJS from 'crypto-js';
import keycloak from '../../src/common/Keycloak';
import moment from 'moment'
const { URL } = require("url");
const path = require("path");

export default {
  methods:{
      PageTracker(data){
        data.routeurl = this.$route.path;
        axios({
            method: 'POST',
            url: apiUrl.tracker_url + 'api/UserTracker',
            data: data
          })
          .then(async result => {
            return result;
          }, error => {
            return false;
            console.error(error)
          })
        //return names;
      },
      getHubDetailsbyID(userid,hubid) {
            return new Promise((resolve,reject)=> {
              let apiendpoint = 'external/getHubListaccessForUser';
              if (keycloak.enableKavach) {
                apiendpoint = 'user/migration/getaccesshublist';
              }
              axios.post(apiUrl.api_url + apiendpoint, {
                "userid": userid
              })
              .then((response) => {
                  if(response.data.code===200){
                    let hubaccess = response.data.data.hubaccess;
                    let getcurrenthubobj = hubaccess.find(hubs => hubs.HubID == hubid );
                    resolve(getcurrenthubobj)
                  }
                  else {
                  this.$alertify.error(response.data.message);
                  }
              })
              .catch((httpException) => {
                  console.error('exception is:::::::::', httpException)
              })
            })
            .catch((e)=>{
              console.log('Hub Details error logs: ',e);
            })
          },
          getHubDeliverySRList(hubId,IsBasicSelectObj = false){

            return new Promise((resolve,reject) => {
              if(hubId) {
                this.input = {
                  "usertype":"3",
                	"hubid":[hubId]
                }
                let apiendpoint = 'expose/users/HubDeliveryUsers/get/List';
                if (keycloak.enableKavach) {
                  apiendpoint = 'user/migration/gethubdeliveryuserlist';
                }
                axios({
                  method: 'POST',
                  url: apiUrl.api_url + apiendpoint,
                  data: this.input
                })
                .then(result => {
                  //console.log('result.data',result.data.data.);
                  let srArrayList = [];
                  if (result.data.data.code == 200) {
                    let resultObj = result.data.data.results;
                    if( IsBasicSelectObj == true ){
                      $.each(resultObj , (key, obj)=>{
                        srArrayList.push({
                          value: obj.userid,
                          text: `${obj.FirstName} ${obj.LastName} (${obj.OldDeliveryUserOrUserId}) (${obj.userid})`
                        })
                      })
                    } else {
                      srArrayList = resultObj;
                    }
                  } else {
                    this.$alertify.error(result.data.data.message?result.data.data.message:'No Delivery SR found');
                    srArrayList = [];
                  }
                  resolve(srArrayList);
                }, error => {
                  resolve(srArrayList);
                })
              } else {
                this.$alertify.error("Current Hub Id not found.")
              }
            })
            .catch((error)=>{
              console.log('Delivery SR list error',new Error(error));
            })
          },
        validateJwtToken() {
          return new Promise((resolve, reject) => {
            let isLoginAuthCheck = window.localStorage.getItem('isLoginAuthCheck');
            if (keycloak.enableKavach) {
              if (keycloak.tokenExpired) {
                keycloak.logoutWithTokenId();
              } else {
                resolve(true)
              }
            }else{
              if(isLoginAuthCheck == 'true' ) {
                let Refreshtoken = window.localStorage.getItem('refreshToken');
                if(Refreshtoken) {
                  if(!Refreshtoken){
                    return false
                    resolve(false)
                  }
                  let payload;
                  try {
                    let decoded = jwt.verify(Refreshtoken, '$LAST$Mile%#$');
                    // console.log('token validated success.!');
                    resolve(decoded)
                  }catch (err) {
                    if (err instanceof jwt.JsonWebTokenError) {
                      console.log('token expired');
                      localStorage.removeItem('lmaccesspermissiondata')
                      localStorage.removeItem('lmaccessuserdata')
                      localStorage.removeItem('isLoggedIn')
                      localStorage.removeItem('refreshToken')
                      localStorage.removeItem('lmUserToken')
                      localStorage.removeItem('userUniqueKey')
                      this.$router.push({ name: 'login' })
                      this.$alertify.error('Your session has been expired, Please login again.!')
                    }
                    return false
                    resolve(false)
                  }
                } else {
                  //if token key is not their in the localStorage then force logout to the user
                  // console.log('force logout initiated');
                  localStorage.removeItem('lmaccesspermissiondata')
                  localStorage.removeItem('lmaccessuserdata')
                  localStorage.removeItem('isLoggedIn')
                  localStorage.removeItem('IsRVPPaperless')
                  localStorage.removeItem('isLoginAuthCheck')
                  localStorage.removeItem('refreshToken')
                  localStorage.removeItem('lmUserToken')
                  localStorage.removeItem('userUniqueKey')
                  this.$router.push({ name: 'login' })
                  this.$alertify.error('Your session has been expired, Please login again.!')
                }
              } else if(isLoginAuthCheck == null) {
                // force logout
                // console.log('force logout.!!!!!!!!!');
                localStorage.removeItem('lmaccesspermissiondata')
                localStorage.removeItem('lmaccessuserdata')
                localStorage.removeItem('isLoggedIn')
                localStorage.removeItem('IsRVPPaperless')
                localStorage.removeItem('isLoginAuthCheck')
                localStorage.removeItem('refreshToken')
                localStorage.removeItem('lmUserToken')
                localStorage.removeItem('userUniqueKey')
                this.$router.push({ name: 'login' })

              } else {
                // login authentication feature off.
                // console.log('Authentication Flag off .!!!!!!!!!!!!');
                resolve(true)
              }
            }
          })
        },
        checkIsLocusEnableforhub() {
          return new Promise((resolve,reject) => {
            try {

              //authentication locus flag.
              const getlocusroutingflag = window.localStorage.getItem('IsLocusRouting')
              console.log('getlocusroutingflag ---->>', getlocusroutingflag);
              if(getlocusroutingflag && getlocusroutingflag != null) {
                const locusFlagdecryptstring = CryptoJS.AES.decrypt(getlocusroutingflag.toString(), 'LocusKey');
                const locusFlagString = locusFlagdecryptstring.toString(CryptoJS.enc.Utf8);
                const locusrouteFlag = JSON.parse(locusFlagString)
                console.log('locusrouteFlag ------->>>>>>>>',locusrouteFlag);
                if(locusrouteFlag != null && locusrouteFlag == "1") {
                  resolve(true)
                } else {
                  // this.$alertify.error('Your are not authorized user/hub for locus module.!')
                  // this.$router.push('/dashboard')
                  resolve(false)
                }
              } else {
                resolve(false)
              }

            } catch(e) {
              console.log('something went wrong, please retry again',e);
            }
          })
        },

        checkIsDayendClosureEnableforhub() {
          return new Promise((resolve,reject) => {
            try {
              //authentication DayEnd Closure flag.
              const getDayEndClosureFlag = window.localStorage.getItem('isDayendclosurefeature')
              //console.log('getDayEndClosureFlag ---->>', getDayEndClosureFlag);
              if(getDayEndClosureFlag && getDayEndClosureFlag != null) {
                const dayEndFlagdecryptstring = CryptoJS.AES.decrypt(getDayEndClosureFlag.toString(), 'DayEndClosureKey');
                const dayEndClosureFlagString = dayEndFlagdecryptstring.toString(CryptoJS.enc.Utf8);
                const dayEndClosureFlag = JSON.parse(dayEndClosureFlagString)
                //console.log('dayEndClosureFlag ------->>>>>>>>',dayEndClosureFlag);
                if(dayEndClosureFlag != null && dayEndClosureFlag == "1") {
                  resolve(true)
                }
                else{
                  resolve(false)
                }
              }
              else {
                resolve(false)
              }
            }
            catch(e) {
              console.log('something went wrong, please retry again',e);
            }
          })
        },

        getMisrouteEnabledFlag(hubid){
          return new Promise( (resolve, reject) => {
            axios.post(apiUrl.api_url + 'misroute/general/getmisroutehubflag', {"hubId":hubid})
            .then((response) => {
              if(response.data.code == 200){
                let resObj = {}
                resObj.flagDel = response.data.data.misrouteEnabledFlagDel;
                resObj.flagRvp = response.data.data.misrouteEnabledFlagRvp;
                resObj.flagRtoDto = response.data.data.RTODTOmisrouteEnabledFlag;
                resObj.isGeoEnabledForUI = response.data.data.addressPrecedenceShadowModeFlag;
                return resolve(resObj);
              }
              else{
                return resolve(false);
              }
            })
            .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
            })
          })
        },
        CheckManualInscanDisableFlagonDEC(hubid){
          return new Promise( (resolve, reject) => {
            axios.post(apiUrl.api_url + 'DayEndClosure/CheckManualInscanDisabledFlag', {"hubId":hubid})
            .then((response) => {
              if(response.data.code == 200){
                let manualInscanEnabledFlag = response.data.data.manualInscanDisableFlag;
                if(manualInscanEnabledFlag == true){
                    return resolve(true);
                }else {
                    return resolve(false);
                }
              }
              else{
                return resolve(false);
              }
            })
            .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
            })
          })
        },
      // Key generate for User Increption and decription
      generateEncryptDecryptKey() {
           let dt = moment().valueOf()
          let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
          let uniqueKey = "";
          for (let i = 0; i < 5; i++){
            uniqueKey += possible.charAt(Math.floor(Math.random() * possible.length));
          }
          return uniqueKey+dt;
      },
      async ValidateLostAuthAccess(userinfo) {
        try {
          const getLostAuthconfig = await this.getLostAuthDetailsFromRedis();
          if( getLostAuthconfig  ) {
            const { islostAuthCheck, dbdepartment, dbdesignation, dbjobprofile } = getLostAuthconfig

            if( islostAuthCheck ) {

              const { department, designation, jobProfile }  = userinfo; //get details from loggedin users.

              console.log('department ---------->>',department , designation, jobProfile );
              console.log('getconfig ---------->>',getLostAuthconfig );

              if( !department || !jobProfile ) {
                this.$alertify.error('Permission denied: Incomplete profile mapping.')
                return false;
              }

              let userDataKey = window.localStorage.getItem('userUniqueKey');
              let IsRSCEncrypt = window.localStorage.getItem('IsRSC')
              let plainconversion = (CryptoJS.AES.decrypt(IsRSCEncrypt.toString(), userDataKey)).toString(CryptoJS.enc.Utf8);
              let HubIsRSCVal = JSON.parse(plainconversion);

              const departmentValues = dbdepartment.split(",");
              // const designationValues = dbdesignation.split(",");
              const jobprofileValues = dbjobprofile.split(",");
              if( departmentValues.includes(department.toLowerCase()) && jobprofileValues.includes(jobProfile.toLowerCase())) {
                 if( HubIsRSCVal ) {
                  let reqobj = { jobRoleName: jobProfile }
                  let getJobRole = await this.getLostRoleFromLostConfigTable(reqobj);
                  if( getJobRole.length ) {
                    if (getJobRole[0].lossrole.toLowerCase() == 'hub incharge') {
                      this.$alertify.error('You are not authorized to handle lost system, Please reach out to Cluster and above.!')
                      return false;
                    }
                  }
                }
                console.log("Success :");
                return true;
              } else {
                console.log('Failed :');
                this.$alertify.error('Access denied: You are not authorized to handle lost items.')
                return false;
              }
            } else {
              console.log('Lost Auth Check Feature is OFF');
              return true;
            }
          } else {
            console.log('Lost Config details are not found');
            this.$alertify.error('Permission denied: Incomplete profile mapping.')
            return false;
          }
        } catch(e) {
          console.log("Lost Authentication failed to validate", e);
          this.$alertify.error('Permission denied: Incomplete profile mapping.')
          return false;
        }
      },
      getLostAuthDetailsFromRedis() {
        return new Promise((resolve, reject) => {
          try {
            let reqpayload = {
              "key": "lostauthconfig"
            }
            axios.post(apiUrl.api_url + 'rediscluster/get', reqpayload)
              .then((response) => {
                if (response.data && response.data.code === 200) {
                  resolve(JSON.parse(response.data.message))
                } else {
                  resolve(false)
                }
              })
          } catch(err) {
            console.log("Error while fetching lost auth details.!", err);
          }
        })
      },
      getDataFromRedisbyKeyNameCommonFun(keypayload){
        return new Promise((resolve) => {
          try {
            axios.post(apiUrl.api_url + 'rediscluster/get', keypayload)
              .then((response) => {
                if (response.data.code === 200) {
                  resolve(JSON.parse(response.data.message))
                } else {
                  resolve(false);
                }
              })
              .catch((e) => {
                console.log("Unable to read data from redis.!", e);
                resolve(false);
              })
          } catch (e) {
            console.log("Unable to read data from redis.!", e);
            resolve(false);
          }
        })
      },
      getLostRoleFromLostConfigTable(requestobj){
        return new Promise((resolve, reject) => {
          try {
            axios.post(apiUrl.api_url + 'shipmentLost/lostJobRoleConfigs', requestobj)
              .then((response) => {
                if (response.data.code === 200) {
                  resolve([response.data.data])
                } else {
                  resolve([])
                }
              })
          } catch (e) {
            console.log("Unable to read data from job config db.!", e);
          }
        })
      },
      getFileExtension(presignedUrl) {
        try {
          const urlObj = new window.URL(presignedUrl);
          const key = urlObj.pathname.substring(1);
          const ext = key.split('.').pop();
          return key.includes('.') ? ext.toLowerCase() : '';
        } catch (err) {
          console.error("Invalid URL:", err);
          return '';
        }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/PageTrackerHelper.js